export const asIcon = <T>(Icon: T) => Icon as unknown as React.FC<React.SVGProps<SVGSVGElement>>
